import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { StarbaseDataService, FilterParams, ContactModel, StarbaseComponentMessage } from 'starbase-launcher';
import { WebApiService } from 'starbase-login';
import { ContactPhone_ext } from '../models/contact-phone-ext';
import { StarbaseComponentMessageService } from './starbase-component-message.service';

@Injectable({
  providedIn: 'root'
})
export class ContactPhoneService extends StarbaseDataService<ContactPhone_ext> {
  public currentContactId: number;
  public currentContactObj: ContactModel;

  protected _staleDataTimeout = 2500;
  protected _getOneUri: string;
  protected _getAllUri = '/api/ContactPhones/GetByContact?contactId=';
  protected _postUri = '/api/ContactPhones';
  protected _putUri = '/api/ContactPhones/';
  protected _deleteUri = '/api/ContactPhones/';
  protected _broadSearchUri: string;

  constructor(private sbCmpMsg: StarbaseComponentMessageService, private _http: HttpClient, _webApiSvc: WebApiService) {
    super(_http, _webApiSvc);
  }

  getDataByFilterParamsBroadSearch(url: string, filterParams: FilterParams<ContactPhone_ext>): Observable<FilterParams<ContactPhone_ext>> {
    throw new Error('Method not implemented.');
  }

  // override to intercept contact Id param
  public getAllData(url: string, retryCount: number = null): Observable<ContactPhone_ext[]> {
    if (this.currentContactId === 0) {
      return of([]);
    }
    url = this.getAllUri + this.currentContactId;
    this.forceStaleData();
    return super.getAllData(url, retryCount);
  }

  // override to intercept posted object and add in correct info
  public postData(url: string, postObject: ContactPhone_ext): Observable<ContactPhone_ext> {
    if (this.currentContactId === 0) {
      console.log('Postponing save; adding phone record to pending new contact.');
      if (!this.currentContactObj.commTypesPhone) {
        this.currentContactObj.commTypesPhone = [];
      }
      this.currentContactObj.commTypesPhone.push(postObject);
      this.sbCmpMsg.handleStarbaseComponentMsg(
        StarbaseComponentMessage.errorMessageForUser(
          'Cannot save phone number',
          'Please save your new contact first, then try again.'));
      return of();
    }
    postObject.contactUID = this.currentContactId;
    postObject.smsSuffix = postObject.receiveSMS ? '@vtext.com' : ''; // TODO: when SMS carrier LU table is made, this should be changed.
    // Currently just assuming Verizon.
    return super.postData(url, postObject);
  }

}
